/* ==========================================================================
   Footer Background Animation
   ========================================================================== */

// ...

import gsap from "gsap";

var isSafari =
  /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);

if (!isSafari) {
  let morph = gsap.to("#bgstart", {
    attr: {
      d: "M36.7,-35.9C49.7,-23.7,63.8,-11.9,66.4,2.6C69,17.1,60.2,34.2,47.2,43.8C34.2,53.3,17.1,55.3,-2.8,58.1C-22.8,61,-45.6,64.7,-60.5,55.2C-75.5,45.6,-82.5,22.8,-76.7,5.8C-71,-11.3,-52.4,-22.6,-37.5,-34.8C-22.6,-47,-11.3,-60.1,0.3,-60.4C11.9,-60.6,23.7,-48.1,36.7,-35.9Z",
    },
    duration: 5,
    paused: false,
    repeat: -1,
    yoyoEase: "sine.out",
    ease: "sine.out",
    rotate: 14,
  });

  let morph2 = gsap.to("#bgstart2", {
    attr: {
      d: "M62.6,-53.5C78.5,-46.7,87,-23.3,84.8,-2.2C82.6,18.9,69.7,37.9,53.8,53.2C37.9,68.6,18.9,80.3,1.8,78.5C-15.3,76.7,-30.6,61.3,-42.3,45.9C-53.9,30.6,-62,15.3,-65.6,-3.6C-69.2,-22.5,-68.4,-45,-56.7,-51.8C-45,-58.6,-22.5,-49.8,0.4,-50.2C23.3,-50.6,46.7,-60.3,62.6,-53.5Z",
    },
    duration: 3,
    paused: false,
    repeat: -1,
    yoyoEase: "sine.out",
    ease: "sine.out",
    rotate: 14,
    xPercent: -25,
  });
}

let shape03 =
  "M36.7,-35.9C49.7,-23.7,63.8,-11.9,66.4,2.6C69,17.1,60.2,34.2,47.2,43.8C34.2,53.3,17.1,55.3,-2.8,58.1C-22.8,61,-45.6,64.7,-60.5,55.2C-75.5,45.6,-82.5,22.8,-76.7,5.8C-71,-11.3,-52.4,-22.6,-37.5,-34.8C-22.6,-47,-11.3,-60.1,0.3,-60.4C11.9,-60.6,23.7,-48.1,36.7,-35.9Z";

let morphSlider = gsap.to("#bgslider", {
  attr: { d: shape03 },
  duration: 9,
  paused: false,
  repeat: -1,
  yoyoEase: "sine.out",
  ease: "sine.out",
});
